export enum FuncionalidadeEnum {
  RENEGOCIACAO = 'RENEGOCIACAO',
  SEGUNDA_VIA = 'SEGUNDA_VIA',
}
